import { AUTHORIZATION_PERMISSIONS, createAuthorization } from '@/utils/authorization';

/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(
  initialState:
    | {
        currentUser?: API.CurrentUser;
        roles?: string[];
        permissions?: string[];
        schedulingUser: object;
        isBusinessLeader?: boolean;
        isMainProductManager?: boolean;
        isSystemInterfaceManager?: boolean;
      }
    | undefined,
) {
  const { currentUser, roles = [], permissions = [], schedulingUser } = initialState ?? {};
  const authorization = createAuthorization({ permissions, roles });
  const { can, hasRole, hasAnyRole } = authorization;
  const isCto = hasRole('CTO');
  const withCto = (accessible: boolean | undefined) => Boolean(isCto || accessible);
  // 兼容前后端分批发布：新权限码优先，旧身份关系仅作为迁移期兜底。
  const canViewTeamEfficiency =
    can(AUTHORIZATION_PERMISSIONS.efficiencyTeamView) || withCto(hasRole('team_leader'));
  const canViewBusinessEfficiency =
    can(AUTHORIZATION_PERMISSIONS.efficiencyBusinessView) ||
    withCto(
      Boolean(
        initialState?.isBusinessLeader ||
          initialState?.isMainProductManager ||
          initialState?.isSystemInterfaceManager,
      ),
    );
  const canViewEfficiencySummary =
    can(AUTHORIZATION_PERMISSIONS.efficiencySummaryView) ||
    withCto(Boolean(initialState?.isBusinessLeader || initialState?.isMainProductManager));
  const canViewEfficiencyComparison =
    can(AUTHORIZATION_PERMISSIONS.efficiencyComparisonView) || Boolean(isCto);

  return {
    //值班人
    canScheduling:
      currentUser && schedulingUser && currentUser.userName === schedulingUser?.userCode,
    can,
    canAny: authorization.canAny,
    // 仅供尚未迁移的旧页面使用，迁移完成后删除。
    normalRolesFilter: (role: string[]) => hasAnyRole(role),
    canAdmin: hasRole('admin'),
    canSls: withCto(hasRole('sls')),
    canWebLog: withCto(hasRole('webLog')),
    canLogCenter: withCto(hasRole('logCenter')),
    canDevelopLog: withCto(hasRole('developLog')),
    canCS: withCto(hasRole('clickVisual')),
    canTool: withCto(hasAnyRole(['sls', 'clickVisual', 'polarDB'])),
    canCto: isCto,
    canDevops: withCto(hasRole('devops')),
    canLeader: withCto(hasRole('team_leader')),
    canApproval: withCto(hasAnyRole(['approval_admin'])),
    canViewTeamEfficiency,
    canViewBusinessEfficiency,
    canViewEfficiencySummary,
    canViewEfficiencyComparison,
    canManageEfficiencyComparison:
      can(AUTHORIZATION_PERMISSIONS.efficiencyComparisonManage) || isCto,
    canGrayReleaseConfig: withCto(hasRole('gray_release_config')),
    canUatRelease: hasRole('uat_release'),
    canProdRelease: hasRole('prod_release'),
    canK8sConfig: withCto(hasRole('devops')), // k8s集群配置权限
    canViewBusiness: withCto(
      hasAnyRole(['PO', 'PMO']) ||
        // initialState?.isBusinessLeader,
        Boolean(initialState?.isBusinessParticipant),
    ),
    canIssueDashboard: withCto(hasAnyRole(['PMO', 'PO', 'Product Manager'])),
    canAiCoding: withCto(hasAnyRole(['frontend', 'backend'])),
    canFeedbackAdmin: withCto(hasRole('FBM')),
    canLcAdmin: withCto(hasRole('card_like_manager')),
    // canDelivery: roles?.includes('qa'),
  };
}
